import PostComponent from "./PostComponent";

export default PostComponent


// WEBPACK FOOTER //
// ./src/components/PostComponent/index.ts